module.exports = __webpack_public_path__ + "static/media/amy_zhang.222e3fa9.png";